import { FC, useMemo } from 'react';

import { SortType } from 'utils/constants/common';

import { Text } from '@hh.ru/magritte-ui';
import { TextTypography } from '@hh.ru/magritte-ui-typography/types';
import { ArrowDownOutlinedSize16, ArrowUpOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import styles from 'components/AccountsControl/components/LabelSortMagritte.module.less';

interface Sort {
    key: string;
    sort: SortType;
}

interface LabelSortMagritteProps {
    columnKey: string;
    label: string;
    typography: TextTypography;
    sorts: Sort[];
    onClick: () => void;
    canSort?: boolean;
}

export const LabelSortMagritte: FC<LabelSortMagritteProps> = ({
    columnKey,
    label,
    typography,
    sorts,
    canSort = true,
    ...props
}) => {
    const direction = useMemo(() => {
        const lastSort = sorts.length > 0 ? sorts[sorts.length - 1] : false;
        return lastSort && lastSort.key === columnKey ? lastSort.sort : '';
    }, [columnKey, sorts]);

    return (
        <div className={styles.labelSort} {...props}>
            <Text typography={typography} style={direction ? 'primary' : 'secondary'}>
                {label}
            </Text>
            {canSort && (
                <div>
                    {direction === SortType.ASC && <ArrowDownOutlinedSize16 initialColor="primary" />}
                    {direction === SortType.DESC && <ArrowUpOutlinedSize16 initialColor="primary" />}
                    {!direction && <ArrowDownOutlinedSize16 initialColor="secondary" />}
                </div>
            )}
        </div>
    );
};
